module.exports = __webpack_public_path__ + "static/media/bootstrap-solid.71d60672.svg";